import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect, useRef, useState } from 'react'
import { Button } from '@/components/ui/button'
// icons
import { IconSettings, IconChevronLeft, IconHome, IconDeviceFloppy, IconPencil, IconCheck, IconX, IconCode, IconPencilQuestion, IconPinnedFilled, IconSlash } from '@tabler/icons-react'

// project imports
// import Settings from 'views/settings'
import SaveChatflowDialog from '../../components/dialog/SaveChatflowDialog'
// import APICodeDialog from '../chatflows/APICodeDialog'

// API
import chatflowsApi from '../../api/chatflows'

// Hooks
import useApi from '../../hooks/useApi'

// utils
import { generateExportFlowData } from '../../utils/genericHelper'
import { uiBaseURL } from '../../store/constant'
import { SET_CHATFLOW } from '../../store/actions'
import { RootState } from '@/store'

// ==============================|| CANVAS HEADER ||============================== //

const CanvasHeader = ({ chatflow, handleSaveFlow, handleDeleteFlow, handleLoadFlow, openChatBox, templateFlowData, agentflowName, setFlowName, flowName }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const flowNameRef = useRef<any>()
    const settingsRef = useRef()

    const [isEditingFlowName, setEditingFlowName] = useState(false)
    const [isSettingsOpen, setSettingsOpen] = useState(false)
    const [flowDialogOpen, setFlowDialogOpen] = useState(false)
    const [apiDialogOpen, setAPIDialogOpen] = useState(false)
    const [apiDialogProps, setAPIDialogProps] = useState({})

    const updateChatflowApi: any = useApi(chatflowsApi.updateChatflow)
    const canvas = useSelector((state: RootState) => state.canvas)

    const onSettingsItemClick = (setting) => {
        setSettingsOpen(false)

        if (setting === 'deleteChatflow') {
            handleDeleteFlow()
        } else if (setting === 'duplicateChatflow') {
            try {
                localStorage.setItem('duplicatedFlowData', chatflow.flowData)
                window.open(`${uiBaseURL}/addtool`, '_blank')
            } catch (e) {
                console.error(e)
            }
        } else if (setting === 'exportChatflow') {
            try {
                const flowData = JSON.parse(chatflow.flowData)
                const dataStr = JSON.stringify(generateExportFlowData(flowData))
                const dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr)
                const  exportFileDefaultName = `${chatflow.name} Chatflow.json`
                const linkElement = document.createElement('a')
                linkElement.setAttribute('href', dataUri)
                linkElement.setAttribute('download', exportFileDefaultName)
                linkElement.click()
            } catch (e) {
                console.error(e)
            }
        }
    }

    const onUploadFile = (file) => {
        setSettingsOpen(false)
        handleLoadFlow(file)
    }

    const submitFlowName = () => {
        if (chatflow.id) {
            const updateBody = {
                displayName: flowNameRef?.current?.value,
                id: chatflow.id
            }
            updateChatflowApi.request(updateBody)
        }
    }

    const onAPIDialogClick = () => {
        let isFormDataRequired = false
        try {
            const flowData = JSON.parse(chatflow.flowData)
            const nodes = flowData.nodes
            for (const node of nodes) {
                if (node.data.inputParams.find((param) => param.type === 'file')) {
                    isFormDataRequired = true
                    break
                }
            }
        } catch (e) {
            console.error(e)
        }

        let isSessionMemory = false
        try {
            const flowData = JSON.parse(chatflow.flowData)
            const nodes = flowData.nodes
            for (const node of nodes) {
                if (node.data.inputParams.find((param) => param.name === 'sessionId')) {
                    isSessionMemory = true
                    break
                }
            }
        } catch (e) {
            console.error(e)
        }

        setAPIDialogProps({
            title: 'Embed in website or use as API',
            chatflowid: chatflow.id,
            chatflowApiKeyId: chatflow.apikeyid,
            isFormDataRequired,
            isSessionMemory
        })
        setAPIDialogOpen(true)
    }

    const onSaveChatflowClick = () => {
        // if (chatflow.id) handleSaveFlow(flowName)
       setFlowDialogOpen(true)
    }

    const onConfirmSaveName = (flowName) => {
        setFlowDialogOpen(false)
        handleSaveFlow(flowName)
    }

    // useEffect(() => {
    //     if (updateChatflowApi.data) {
    //         setFlowName(updateChatflowApi.data.name)
    //         dispatch({ type: SET_CHATFLOW, chatflow: updateChatflowApi.data })
    //     }
    //     setEditingFlowName(false)
    // }, [updateChatflowApi.data])

    // useEffect(() => {
    //     if (chatflow) {
    //         setFlowName(chatflow.name)
    //     }
    // }, [chatflow])

    return (
        <>
            <div className="flex items-center ml-5">
                <Button
                    variant='ghost'
                    onClick={() =>
                        window.history.state && window.history.state.idx > 0 ? navigate(-1) : navigate('/', { replace: true })
                    }
                >
                    <IconHome stroke={1.5} size='1.3rem' /> 
                </Button>
                <IconSlash 
                    stroke={1.5} 
                    size='1.3rem' 
                    className="rotate-175 transition-transform duration-300 ease-in-out" 
                />
                {/* {!isEditingFlowName && ( */}
                    <div className="flex items-center p">
                        <h1 className="text-xl font-semibold">
                            {flowName}
                           {/* {canvas.isDirty && <strong className="text-orange-500">*</strong>} */}   
                        </h1>
                        {/* {chatflow?.id && (
                            <Button
                                title='Edit Name'
                                onClick={() => setEditingFlowName(true)}
                            >
                                <IconPencil stroke={1.5} size='1.3rem' />
                            </Button>
                        )} */}
                    </div>
                {/* )} */}
                {/* {isEditingFlowName 
                && ( 
                    // <div className="flex items-center ">
                    //     <input
                    //         type='text'
                    //         ref={flowNameRef}
                    //         className="w-1/2 p-2 border border-gray-300 rounded-md ml-2"
                    //         defaultValue={flowName}
                    //     />
                    //     <Button
                    //     variant="outline"
                    //         onClick={submitFlowName}
                    //     >
                    //       Save Name  <IconCheck stroke={1.5} size='1.3rem' />
                    //     </Button>
                    //     <Button
                    //         variant="outline"
                    //         onClick={() => setEditingFlowName(false)}
                    //     >
                    //        Cancel <IconX stroke={1.5} size='1.3rem' />
                    //     </Button>
                    // </div>
                // )}*/}
            </div>

            <div className="flex items-center">
                {/* {chatflow?.id && (
                    <Button
                    variant="outline"
                    onClick={onAPIDialogClick}
                >
                  API Endpoint  <IconCode stroke={1.5} size='1.3rem' />
                </Button>
                )} */}

                <Button variant="outline"
                    onClick={onSaveChatflowClick}
                     size='sm' className='ml-2'
                >
                    <IconDeviceFloppy stroke={1.5} size='1.3rem' /> Save
                </Button>

        <Button  onClick={openChatBox} variant="outline" size='sm' className='ml-2'>
                <IconPencilQuestion  stroke={1.5} size='1.2rem' className='mr-1'/>
        Test
        </Button>

        <Button variant="outline" size='sm' className='ml-2' onClick={() => setSettingsOpen(!isSettingsOpen)}>
                <IconPinnedFilled stroke={1.5} size='1.2rem' className='mr-1'/>
        Deploy
        </Button>
            </div>

            <SaveChatflowDialog
                show={flowDialogOpen}
                dialogProps={{
                    title: `Save New Chatflow`,
                    confirmButtonName: 'Save',
                    cancelButtonName: 'Cancel'
                }}
                onCancel={() => setFlowDialogOpen(false)}
                onConfirm={onConfirmSaveName}
                flowName={flowName}
            />
            {/* <APICodeDialog show={apiDialogOpen} dialogProps={apiDialogProps} onCancel={() => setAPIDialogOpen(false)} /> */}
        </>
    )
}

CanvasHeader.propTypes = {
    chatflow: PropTypes.object,
    handleSaveFlow: PropTypes.func,
    handleDeleteFlow: PropTypes.func,
    handleLoadFlow: PropTypes.func,
    openChatBox: PropTypes.func,
    templateFlowData: PropTypes.any,
    agentflowName: PropTypes.string
}

export default CanvasHeader
